/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FormElementSubSectionSnapshotDto } from './FormElementSubSectionSnapshotDto';
import {
    FormElementSubSectionSnapshotDtoFromJSON,
    FormElementSubSectionSnapshotDtoFromJSONTyped,
    FormElementSubSectionSnapshotDtoToJSON,
    FormElementSubSectionSnapshotDtoToJSONTyped,
} from './FormElementSubSectionSnapshotDto';

/**
 * 
 * @export
 * @interface FormElementSectionSnapshotDto
 */
export interface FormElementSectionSnapshotDto {
    /**
     * 
     * @type {string}
     * @memberof FormElementSectionSnapshotDto
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof FormElementSectionSnapshotDto
     */
    shortTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof FormElementSectionSnapshotDto
     */
    description?: string;
    /**
     * 
     * @type {Array<FormElementSubSectionSnapshotDto>}
     * @memberof FormElementSectionSnapshotDto
     */
    subsections: Array<FormElementSubSectionSnapshotDto>;
    /**
     * 
     * @type {boolean}
     * @memberof FormElementSectionSnapshotDto
     */
    isTemplate?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FormElementSectionSnapshotDto
     */
    templateReference?: string;
    /**
     * 
     * @type {string}
     * @memberof FormElementSectionSnapshotDto
     */
    titleTemplate?: string;
    /**
     * 
     * @type {string}
     * @memberof FormElementSectionSnapshotDto
     */
    spawnedFromElementReference?: string;
    /**
     * If true, this section is deferred while the form is in its trial period.
     * @type {boolean}
     * @memberof FormElementSectionSnapshotDto
     */
    deferredDuringTrial?: boolean;
}

/**
 * Check if a given object implements the FormElementSectionSnapshotDto interface.
 */
export function instanceOfFormElementSectionSnapshotDto(value: object): value is FormElementSectionSnapshotDto {
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('subsections' in value) || value['subsections'] === undefined) return false;
    return true;
}

export function FormElementSectionSnapshotDtoFromJSON(json: any): FormElementSectionSnapshotDto {
    return FormElementSectionSnapshotDtoFromJSONTyped(json, false);
}

export function FormElementSectionSnapshotDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormElementSectionSnapshotDto {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'],
        'shortTitle': json['shortTitle'] == null ? undefined : json['shortTitle'],
        'description': json['description'] == null ? undefined : json['description'],
        'subsections': ((json['subsections'] as Array<any>).map(FormElementSubSectionSnapshotDtoFromJSON)),
        'isTemplate': json['isTemplate'] == null ? undefined : json['isTemplate'],
        'templateReference': json['templateReference'] == null ? undefined : json['templateReference'],
        'titleTemplate': json['titleTemplate'] == null ? undefined : json['titleTemplate'],
        'spawnedFromElementReference': json['spawnedFromElementReference'] == null ? undefined : json['spawnedFromElementReference'],
        'deferredDuringTrial': json['deferredDuringTrial'] == null ? undefined : json['deferredDuringTrial'],
    };
}

export function FormElementSectionSnapshotDtoToJSON(json: any): FormElementSectionSnapshotDto {
    return FormElementSectionSnapshotDtoToJSONTyped(json, false);
}

export function FormElementSectionSnapshotDtoToJSONTyped(value?: FormElementSectionSnapshotDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'shortTitle': value['shortTitle'],
        'description': value['description'],
        'subsections': ((value['subsections'] as Array<any>).map(FormElementSubSectionSnapshotDtoToJSON)),
        'isTemplate': value['isTemplate'],
        'templateReference': value['templateReference'],
        'titleTemplate': value['titleTemplate'],
        'spawnedFromElementReference': value['spawnedFromElementReference'],
        'deferredDuringTrial': value['deferredDuringTrial'],
    };
}

